// extracted by mini-css-extract-plugin
export default {"active":"CheckboxButton_active__eqdlg","inactive":"CheckboxButton_inactive__WZBAN"};